module.exports = __webpack_public_path__ + "img/unsuccessfullshare.72fefdcb.svg";